import setup from "./setup";
const track = function (event, args, _temp) {
  let {
    renewSession = false,
    includeContext = true
  } = _temp === void 0 ? {} : _temp;
  return setup().then(_ => {
    window.tagular("beam", {
      "@type": event,
      ...args
    }, renewSession, includeContext);
    console.log("%c @analytics/make - track", "color: cornflowerblue", {
      event,
      ...args
    });
  });
};
export default {
  track,
  setup
};